/* eslint-disable react/prop-types */
import React from 'react';
import { Col, Form, Checkbox, Skeleton } from 'antd';

const { Item } = Form;

const BadesulCheckBox = ({ input, onUpdate, loading, sizeMap }) => (
  <Col
    {...sizeMap[input.size]}
    className={`checkbox-col-${input.size === '1' ? 'full' : 'not-full'}`}
  >
    <Item
      name={input.value}
      valuePropName="checked"
      onChange={() => {
        onUpdate((value) => !value);
      }}
    >
      {loading ? (
        <Skeleton.Button shape="square" active className="gyramais-input-skeleton" size="large" />
      ) : (
        <Checkbox loading={loading}>{input.name}</Checkbox>
      )}
    </Item>
  </Col>
);

export default BadesulCheckBox;
